import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    InputLabel,
    MenuItem,
    Select,
    FormControl,
    Typography
} from '@mui/material';
import { toast } from 'react-toastify';
import FormGroup from '@mui/material/FormGroup';
import { sendDataToApi } from '../../../API/apiHelper';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IOSSwitch } from '../../../components/UI/CustomizedSwitches';

function CreateInsertBundleDialog({ open, handleClose, onSuccess, adtCompany }) {
    const [enableWhiteListRemoval, setEnableWhiteListRemoval] = useState(false);

    const [formData, setFormData] = useState({
        bandle_name: '',
        type: '',
        adt_id: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'remove_all' ? value === 'true' : value
        }));
    };

    const handleSubmit = () => {
        const userId = localStorage.getItem('user_id');
        const payload = {
            ...formData,
            ChangedBy: userId,
        };

        sendDataToApi('post', '/api/adtimizer/insert-bundles-panel/create', payload, false, (data) => {
            if (data.data.success) {
                toast.success('The company has been created!');
                onSuccess();
                setFormData({
                    bandle_name: '',
                    type: '',
                    adt_id: '',
                });
                handleClose();
            } else {
                toast.error('The company has not been created!');
                toast.error(data.data.error);
            }
        });
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Create a new bundle</DialogTitle>
            <DialogContent sx={{ minWidth: '450px' }}>
                <TextField fullWidth margin="dense" name="bandle_name" label="Bandle Name" value={formData.bandle_name} onChange={handleChange} />

                <FormControl fullWidth margin="dense">
                    <InputLabel id="adt_id">ADT Company ID</InputLabel>
                    <Select
                        labelId="adt_id"
                        id="adt_id"
                        name="adt_id"
                        value={formData.adt_id}
                        onChange={handleChange}
                        required
                        label="ADT Company ID"
                    >
                        {adtCompany.map((item) => (
                            <MenuItem key={item.value.id} value={item.value.id}>
                                {item.value.company_name} (ID: {item.value.id})
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="dense">
                    <InputLabel id="type">Type</InputLabel>
                    <Select
                        labelId="type"
                        name="type"
                        label="Type"
                        value={formData.type.toString()}
                        onChange={handleChange}
                    >
                        <MenuItem value="Android">Android</MenuItem>
                        <MenuItem value="IOS">IOS</MenuItem>
                        <MenuItem value="WEB">WEB</MenuItem>
                        <MenuItem value="CTV">CTV</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSubmit}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}

export default CreateInsertBundleDialog;
